import { TillOrderStatus } from "../../../@types/till";

type DispenseTillLine = { status?: string };

export function getLatestDispenseTillLine(till: {
  dispenseTills?: DispenseTillLine[] | null;
}): DispenseTillLine | undefined {
  const arr = till.dispenseTills;
  if (!arr?.length) return undefined;
  return arr[arr.length - 1];
}

export function getLatestTillLineStatus(till: {
  dispenseTills?: DispenseTillLine[] | null;
}): TillOrderStatus | null {
  const line = getLatestDispenseTillLine(till);
  const s = line?.status;
  if (!s) return null;
  const allowed = Object.values(TillOrderStatus) as string[];
  return allowed.includes(s) ? (s as TillOrderStatus) : null;
}
